import { Checkbox, MenuItem, Stack, TableCell, TableHead, TableRow } from "@mui/material";
import { ReactComponent as CheckboxOff } from "assets/images/icons/checkbox-off.svg";
import { ReactComponent as CheckboxOn } from "assets/images/icons/checkbox-on.svg";
import { ReactComponent as MemberIcon } from "assets/images/icons/member.svg";
import { ReactComponent as TrashIcon } from "assets/images/square-buttons/squared-trash.svg";
import { ReactComponent as InstructorSwitchIcon } from "assets/images/square-buttons/switch-2.svg";
import ScreenLoader from "components/ScreenLoader";
import Tooltip from "components/Tooltip";
import { GENERIC_MEMBER_STATUS_OPTIONS } from "constants/index";
import SortButton from "containers/Members/SortButton";
import { stringToColor } from "helpers/utils";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";

import MemberListDropdown from "../Dropdown";

export const TableHeader = ({ allCheckFlag, handleAllCheck, pageParams, sortingCallback }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell align="left">
          <Checkbox
            checked={allCheckFlag || false}
            icon={<CheckboxOff />}
            checkedIcon={<CheckboxOn />}
            onChange={handleAllCheck}
          />
          All
        </TableCell>
        <TableCell align="left">
          <SortButton
            label={`Last Name`}
            value={`LAST_NAME`}
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="left">First Name</TableCell>
        <TableCell align="left">FitLinxx ID</TableCell>
        <TableCell align="left">Last Workout Session</TableCell>
        <TableCell align="left">
          <SortButton
            label={`Member Status`}
            value={`STATUS`}
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="right">Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export const TableItem = ({
  data,
  onUpdateStatus,
  isChecked,
  onCheckMember,
  onClickDelete,
  onClickInstructorSwitch,
}) => {
  const [loading, setLoading] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(data?.status);

  useEffect(() => {
    setCurrentStatus(data.status);
  }, [data]);

  const memberStatusOptions = useMemo(() => {
    return GENERIC_MEMBER_STATUS_OPTIONS.map(
      (e, index) =>
        !e.isSelectAll && (
          <MenuItem
            key={`statusddlentry_${data?.id}_${index}`}
            // selected={e.value === status}
            value={e.value}
          >
            {e.label}
          </MenuItem>
        )
    );
  }, []);

  return (
    <TableRow role="checkbox">
      <TableCell align="left">
        <Stack direction={"row"} alignItems="center">
          {/* <Checkbox checked={data.checked} icon={<CheckboxOff />} checkedIcon={<CheckboxOn />} /> */}
          <Checkbox
            checked={isChecked}
            icon={<CheckboxOff />}
            checkedIcon={<CheckboxOn />}
            onClick={(_e) => onCheckMember(data?.id)}
          />
          <span
            style={{ backgroundColor: stringToColor(`${data?.first_name} ${data?.last_name}`) }}
            className={"rounded-circle member-icon"}
          >
            <MemberIcon width={24} height={24} stroke={"#fff"} />
          </span>
        </Stack>
      </TableCell>
      <TableCell align="left" className="bold black" width="15%">
        {data?.last_name}
      </TableCell>
      <TableCell align="left" className="bold black" width="15%">
        {data?.first_name}
      </TableCell>
      <TableCell align="left" className="bold" width="10%">
        {data?.fitlinxx_id}
      </TableCell>
      <TableCell align="left" width="20%">
        {data?.last_workout_session && (
          <>
            <h3 className={"grey"}>{moment(data?.last_workout_session).fromNow()}</h3>
            <p className={"grey"}>
              ({moment(data?.last_workout_session).format(`MM-DD-YYYY HH:mm`).toString()})
            </p>
          </>
        )}
      </TableCell>
      <TableCell align="left" className="bold" width="20%">
        {loading && <ScreenLoader isScreenLoader />}
        {!loading && (
          <MemberListDropdown
            name="status"
            label="Status"
            value={currentStatus}
            defaultValue={currentStatus || ""}
            onChange={(v) => {
              setLoading(true);
              onUpdateStatus(data?.id, v.target.value).then((_e) => {
                setCurrentStatus(v.target.value.toString());
                setLoading(false);
              });
            }}
            fullWidth={true}
            className={`select ${data.status === "IN_ACTIVE" ? `bg-ash` : `bg-primary`}`}
          >
            {memberStatusOptions}
          </MemberListDropdown>
        )}
      </TableCell>
      <TableCell align="right" width="15%">
        <div className={"buttons-bar"}>
          {/* <Tooltip content={"Status Switch"} direction="bottom">
            <button>
              <StatusSwitchIcon />
            </button>
          </Tooltip> */}
          <Tooltip content={"Trash"} direction="bottom">
            <button onClick={() => onClickDelete(data)}>
              <TrashIcon />
            </button>
          </Tooltip>
          <Tooltip content={"Instructor Switch"} direction="bottom">
            <button onClick={() => onClickInstructorSwitch(data)}>
              <InstructorSwitchIcon />
            </button>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  );
};
